import React, { useEffect, useMemo, useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getProductUsageState } from 'redux/rootSelectors';
import { loadCustomersMonth } from 'redux/productUsage/actions';
import { isSuccess } from 'helpers/utils';

export function CustomersMonth() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loadCustomersMonthStatus, customersMonthResponse } = useSelector(getProductUsageState);
  const [customerData, setCustomerData] = useState([]);
  const monthCalendar = useMemo(() => [
    t('months.jan'),
    t('months.feb'),
    t('months.mar'),
    t('months.apr'),
    t('months.may'),
    t('months.jun'),
    t('months.jul'),
    t('months.aug'),
    t('months.sep'),
    t('months.oct'),
    t('months.nov'),
    t('months.dec')
  ], [t]);
  const [labelData, setLabelData] = useState([]);

  const colors = ['#2baca4'];
  function getOptions() {
    return {
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLine: {
          onZero: false
        },
        data: labelData
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: customerData,
          type: 'line',
          smooth: true,
          color: colors,
          name: t('dashboard.tabs.product_usage.customers_month.access_amount')
        }
      ],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      }
    };
  }

  useEffect(() => {
    dispatch(loadCustomersMonth());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess(loadCustomersMonthStatus.status)) {
      const newCustomerData = [];
      const newLabelData = [];
      customersMonthResponse.forEach(value => {
        newCustomerData.push(value.total_accesses);
        const year = value.date.split('-')[0];
        newLabelData.push(`${monthCalendar[value.month - 1]}\n${year}`);
      });
      setCustomerData(newCustomerData);
      setLabelData(newLabelData);
    }
  }, [customersMonthResponse, loadCustomersMonthStatus, monthCalendar]);

  return (
    <Box
      sx={{
        overflow: 'hidden',
        backgroundColor: 'white',
        boxShadow: 2,
        borderRadius: '8px',
        width: '100%',
        p: 1.5
      }}
    >
      <Stack direction="column" spacing={2}>
        <Stack direction="column" spacing={1}>
          <Typography sx={{ fontSize: 16, fontWeight: 'bold' }} gutterBottom>
            {t('dashboard.tabs.product_usage.customers_month.title')}
          </Typography>
          <Typography sx={{ fontSize: 10, color: '#7A7D85' }} gutterBottom>
            {t('dashboard.tabs.product_usage.customers_month.caption')}
          </Typography>
        </Stack>
        <ReactEcharts option={getOptions()} style={{ width: '100%' }} />
      </Stack>
    </Box>
  );
}
